import React from "react";
import { TextField } from "@material-ui/core";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { Card, CardActions, CardHeader } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  card: {
    margin: theme.spacing(1),
    padding: theme.spacing(1),
  },
}));

const SongDetailsInput = () => {
  const classes = useStyles();

  return (
    <Card className={classes.card} elevation={0}>
      <TextField
        id="standard-full-width"
        label="Song Name"
        style={{ margin: 8 }}
        placeholder="Placeholder"
        margin="normal"
        InputLabelProps={{
          shrink: true,
        }}
        variant="outlined"
      />  
      <TextField
        label="Tempo"
        id="margin-none"
        defaultValue="70"
        className={classes.textField}
        margin="normal"
        variant="outlined"
      />
      <TextField
        label="Key"
        id="margin-normal"
        defaultValue="C"
        className={classes.textField}
        margin="normal"
        variant="outlined"
      />
    </Card>
  );
};

export default SongDetailsInput;
